// extracted by mini-css-extract-plugin
module.exports = {"forgottenPassword":"ForgottenPasswordBlock_forgottenPassword__9x00c"};